// import smoothscroll from 'smoothscroll-polyfill';
// import IntersectionObserver from './_main/IntersectionObserver';

import { isIOS } from './utility';
import { CFG } from './config';

// main
import {
    Hamburger,
    AnchorScroll,
    Accordion,
    // OnePageScroll,
    ReservatioinCondition,
    ScrollManager
} from './_main';

// home
import {
    // GoogleMapApi,
    FvScrollTrigger,
    VisualSlides,
} from './_home'

// concept
import {
    ScrollTriggerClass,
} from './_concept';

// sakagura-bar
import {
    ControlSlides,
    ScrollSlides,
    PointerFollow,
} from './_sakagura-bar';

// room-service
import {
    ThumbnailSlides
} from './_room-service';

// main
{
    const domBody = document.body;
    if (isIOS) domBody.dataset.agent = 'ios';

    // smoothscroll.polyfill();

    const domHamburger = document.querySelector('[data-js="trigger"]');
    if (domHamburger) new Hamburger(domHamburger);

    const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    if ( domAnchorScroll ) {
        domAnchorScroll.forEach(el => {
            new AnchorScroll(el);
        });
    }

    const domAccordion = document.querySelectorAll('[data-js="accordion"]');
    if (domAccordion) {
        [...domAccordion].forEach(el=>{
            new Accordion(el);
        })
    }
    
    // const domOnePageScroll = document.querySelector('[data-js="onepage-scroll"]');
    // if (domOnePageScroll) new OnePageScroll(domOnePageScroll);

    const domScrollManager = document.querySelector('[data-js="scrollmanager"]');
    if (domScrollManager) new ScrollManager(domScrollManager);

    // 予約カレンダー
    const domReservatioinCondition = document.querySelector('[data-js="reservation"]');
    if (domReservatioinCondition) new ReservatioinCondition(domReservatioinCondition);
}

// home
{
    const domFvScrollTrigger = document.querySelector('[data-js="fst"]');
    if (domFvScrollTrigger) new FvScrollTrigger(domFvScrollTrigger);

    const domVisualSlides = document.querySelector('[data-js="visual-slide"]');
    if (domVisualSlides) new VisualSlides(domVisualSlides);

    // const domVisualYoutube = document.querySelector('[data-js="bg-movie"]');
    // if (domVisualYoutube) new VisualYoutube(domVisualYoutube);

    // const domGoogleMapApi = document.querySelector('[data-js="googlemap"]');
    // if (domGoogleMapApi) new GoogleMapApi(domGoogleMapApi);
}

// concept
{
    const domScrollTriggerClass = document.querySelectorAll('[data-trigger="stc"]');
    if (domScrollTriggerClass) new ScrollTriggerClass(domScrollTriggerClass);  
}

// sakagura-bar
{
    const domControlSlides = document.querySelectorAll('[data-js="control-slides"]');
    if (domControlSlides) {
        [...domControlSlides].forEach(el=>{
            new ControlSlides(el);
        });
    }

    const domScrollSlides = document.querySelectorAll('[data-js="scroll-slides"]');
    if (domScrollSlides) {
        [...domScrollSlides].forEach(el=>{
            new ScrollSlides(el);
        });
    }

    // ポインター追従
    const domPointerFollow = document.querySelectorAll('[data-js="drag"]');
    if (domPointerFollow) {
        [...domPointerFollow].forEach(el => {
            const pointerFollow = new PointerFollow(el);
        })
        // const mql = window.matchMedia('screen and (min-width: 768px)');
        // let checkBreakPoint = function (_mql) {
        //     if (!_mql.matches) {
        //         // SP
        //         pointerFollow.destroy();
        //     } else {
        //         // PC
        //         pointerFollow.init();
        //     }
        // };
        // // ブレイクポイントの瞬間に発火
        // mql.addListener(checkBreakPoint);
        // // 初回チェック
        // checkBreakPoint(mql);
    }
}

// stay-rooms
{
    const domThumbnailSlides = document.querySelectorAll('[data-js="thumbnail-slider"]');
    if (domThumbnailSlides) {
        [...domThumbnailSlides].forEach(el=>{
            new ThumbnailSlides(el);
        });
    }
}
